'use client';

import { Carousel, CarouselContent, CarouselItem } from '@/src/components/ui/carousel';
import { ICmsSection } from '../services/types';
import { BasicProductDataResponse } from '@/src/types/catalog';
import { useLocale } from 'next-intl';
import { FC } from 'react';
import { PromotedProduct } from './PromotedProduct';
import { ThemeLayout } from './ThemeLayout';
import Typography from '@/src/components/ui/typography';
import Container from '@/src/components/ui/container';
import { useMediaQuery } from '@/src/lib/hooks/useMediaQuery';
import { ProductCard } from '@/src/app/[locale]/stores/[store]/[storeId]/product/components/ProductCard';

type Props = {
  data: ICmsSection;
  globalLiveTimes?: Record<number, string>;
};
export const PromotedProductLayout: FC<Props> = ({ data, globalLiveTimes }) => {
  const slides = (
    Array.isArray(data.content)
      ? data.content
      : (data.content?.products ?? data.content?.Products ?? [])
  ) as BasicProductDataResponse[];
  const currentLang = useLocale();
  const isArabic = currentLang === 'ar';

  const isMobile = useMediaQuery('(max-width: 767px)');
  return (
    <Container>
      <ThemeLayout
        id={data?.id.toString()}
        theme={data?.theme}
        alt={data?.name}
        header={
          <Typography
            align={'start'}
            component={'h2'}
            variant={'h5'}
            color={'text'}
            weight={'semibold'}
            className="text-inherit"
          >
            {data?.name}
          </Typography>
        }
        className="px-14"
      >
        <Carousel>
          <CarouselContent className="ml-0 flex py-3 lg:gap-3">
            {slides?.map((item, index) => {
              const storeId = Number(item.storeId || item.branchId);
              const storeTime = globalLiveTimes?.[storeId] || '';

              return (
                <CarouselItem
                  key={index}
                  dir={isArabic ? 'rtl' : 'ltr'}
                  className="rounded-2xl bg-white px-0"
                >
                  {isMobile ? (
                    <ProductCard productDetails={item} storeTime={storeTime} />
                  ) : (
                    <PromotedProduct productDetails={item} storeTime={storeTime} />
                  )}
                </CarouselItem>
              );
            })}
          </CarouselContent>
        </Carousel>
      </ThemeLayout>
    </Container>
  );
};
